import { render, staticRenderFns } from "./CompanyConfigCrudListView.vue?vue&type=template&id=626e5717&scoped=true&"
import script from "./CompanyConfigCrudListView.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigCrudListView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConfigCrudListView.vue?vue&type=style&index=0&id=626e5717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e5717",
  null
  
)

export default component.exports